import { Button, Card, Col, Form, Input, Row, Typography } from "antd";
import React, { useState } from "react";
import styles from "./Login.module.css";

import { useDispatch } from "react-redux";
import { addUser } from "../../redux/rtk/features/user/userSlice";
import logo1 from "../../assets/images/logo1.png";
import { toast } from "react-toastify";
import LoginTable from "../Card/LoginTable";

const Login = () => {
	const dispatch = useDispatch();
	const [loader, setLoader] = useState(false);
	const { Title } = Typography;

	const onFinish = async (values) => {
		const resp = await dispatch(addUser(values));
		if (resp.payload.message === "success") {
			setLoader(false);
			toast.success("Login successful!");
			window.location.href = "/admin/dashboard";
		} else {
			setLoader(false);
			toast.error("Login failed. Please try again.");
		}
	};

	const onFinishFailed = (errorInfo) => {
		console.log("Failed:", errorInfo);
		setLoader(false);
		toast.error("Error at login. Please try again.");
	};

	return (
		<div className={styles.pageContainer}>
			<Card bordered={false} className={styles.card}>
				<div className={styles.imageContainer}>
					<img src={logo1} alt='Login Logo' className={styles.loginImage} />
				</div>
				<div className='textSecondary'>
					<p className={styles.subtitle}>Please login to your account</p>
				</div>
				<Form
					name='basic'
					labelCol={{ span: 6 }}
					wrapperCol={{ span: 16 }}
					onFinish={onFinish}
					onFinishFailed={onFinishFailed}
					autoComplete='off'>

					<Form.Item
						className='mb-5'
						label='Username'
						name='userName'
						rules={[{ required: true, message: "Please input your username!" }]}>
						<Input placeholder='Enter your username' />
					</Form.Item>

					<Form.Item
						className='mb-5'
						label='Password'
						name='password'
						rules={[{ required: true, message: "Please input your password!" }]}>
						<Input.Password placeholder='Enter your password' />
					</Form.Item>

					<Form.Item className={styles.submitBtnContainer}>
						<Button
							type='primary'
							htmlType='submit'
							loading={loader}
							className={styles.loginButton}
							onClick={() => setLoader(true)}>
							Login
						</Button>
					</Form.Item>

					<Form.Item className={styles.loginTableContainer}>
						<Row>
							<Col span={24}>
								{/* <LoginTable /> */}
							</Col>
						</Row>
					</Form.Item>
				</Form>
			</Card>
		</div>
	);
};

export default Login;
